import { useState, useEffect } from 'react'
import { RadioGroup } from '@headlessui/react'

const sedeMenu = (Sede) => {
    let NameSede = ''

    switch (Sede) {
        case '01':
            NameSede = 'Calzada San Juan'
            break
        case '02':
            NameSede = 'Avenida Petapa'
            break
        case '04':
            NameSede = 'Aguilar Batres'
            break
        case '05':
            NameSede = 'Zona 6'
            break
        case '06':
            NameSede = 'San Cristóbal'
            break
        case '07':
            NameSede = 'Villa Nueva'
            break
        case '08':
            NameSede = 'El Naranjo'
            break
        case '09':
            NameSede = 'Virtual a Distancia'
            break
        case '10':
            NameSede = 'Amatitlán'
            break
        case '11':
            NameSede = 'Jocotenango'
            break
        default:
            break
    }

    return NameSede
}

const MenuSedes = ({ solutions = [], handleClick, Sede, handleChangeSearch, orientacion="center" }) => {

    const [sedeBoton, setSedeBoton] = useState(sedeMenu(Sede))
    
    useEffect(() => {
        setSedeBoton(sedeMenu(Sede))
    }, [Sede])

    const [filter, setFilter] = useState({
        Actuales: true,
        Anteriores: false
    })

    const [filterSearch, setFilterSearch] = useState({
        Nombres: true,
        Carnet: false
    })

    const handleFilter = (FILTER_FLAG) => {
        switch (FILTER_FLAG) {
            case 'ACTUALES':
                setFilter({ Actuales: true, Anteriores: false })
                handleClick(sedeBoton, { Actuales: true, Anteriores: false })
                break;
            case 'ANTERIORES':
                setFilter({ Actuales: false, Anteriores: true })
                handleClick(sedeBoton, { Actuales: false, Anteriores: true })
                break;
            default:
                setFilter({ Actuales: true, Anteriores: false })
                handleClick(sedeBoton, { Actuales: true, Anteriores: false })
                break;
        }
    }
    const handleFilterSearch = (FILTER_FLAG) => {
        switch (FILTER_FLAG) {
            case 'NOMBRES':
                setFilterSearch({ Nombres: true, Carnet: false })
                handleChangeSearch('Aspirante')
                break;
            case 'CARNET':
                setFilterSearch({ Nombres: false, Carnet: true })
                handleChangeSearch('Carnet')
                break;
            default:
                setFilterSearch({ Nombres: true, Carnet: false })
                handleChangeSearch('Aspirante')
                break;
        }
    }

    const handlechangeSede = (sede) => {
        setSedeBoton(sede)
        handleClick(sede, filter)
    }

    return (
        <div className="">

            <nav aria-label="Progress">
                <ul
                    role="list"
                    className={`bg-secundarioMira justify-${orientacion} mt-2 top-30 lg:flex text-white`}
                >
                    <div className="flex flex-row gap-4 max-w-7xl mb-2">
                        <RadioGroup className='flex flex-row gap-4' value={sedeBoton} onChange={setSedeBoton}>
                            {solutions.map((item) => (
                                <RadioGroup.Option key={item.name} value={item.name} >
                                    {({ checked }) => (
                                        <div
                                            key={item.name}
                                            className={`${checked ? 'border-2 bg-secundario' : 'bg-primarioMira'} group relative flex rounded-full px-1 text-sm font-medium shadow-sm hover:bg-primarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2`}
                                            onClick={() => handlechangeSede(item.name)}
                                        >
                                            <div className='text-base'>
                                                <img src={item.img} alt="" className="h-14 w-14 flex-none rounded-full" />
                                                <a href={item.href}>
                                                    <span className="absolute inset-0" />
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </RadioGroup.Option>
                            ))}
                        </RadioGroup>
                    </div>

                    <div className='ml-8 mt-2 flex flex-col gap-1 text-right'>
                        <div>
                            <label className='mr-4 text-sm font-semibold text-white'>Ciclos 2022 - 2023 - 2024</label>
                            <input
                                type='radio'
                                checked={filter.Actuales}
                                onChange={() => handleFilter('ACTUALES')}
                                className='text-secundario' />
                        </div>
                        <div>
                            <label className='mr-4 text-sm font-semibold text-white'>Ciclos anteriores a 2022</label>
                            <input
                                type='radio'
                                checked={filter.Anteriores}
                                onChange={() => handleFilter('ANTERIORES')}
                                className='text-secundario' />
                        </div>
                    </div>
                    <div className='ml-8 mt-2 flex flex-col gap-1 text-right'>
                        <div>
                            <label className='mr-4 text-sm font-semibold text-white'>Búsqueda por nombres ó apellidos</label>
                            <input
                                type='radio'
                                checked={filterSearch.Nombres}
                                onChange={() => handleFilterSearch('NOMBRES')}
                                className='text-secundario' />
                        </div>
                        <div>
                            <label className='mr-4 text-sm font-semibold text-white'>Búsqueda por carnet</label>
                            <input
                                type='radio'
                                checked={filterSearch.Carnet}
                                onChange={() => handleFilterSearch('CARNET')}
                                className='text-secundario' />
                        </div>
                    </div>

                </ul>
            </nav>
        </div >
    );
}

export default MenuSedes